define('models/pages/dashboard/news',[
    'underscore',
    'chaplin',
    'models/base/model',
    'models/base/collection',
    'lib/utils'
], function(_, Chaplin, Model, Collection) {
    'use strict';

    var NewsCollection = Collection.extend({
        constructor: function() {
            Collection.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
        }
    });

    var NewsModel = Model.extend({
        urlPath: '/pages/dashboard/news',
        defaults: {
            caption: 'Новости'
        },
        constructor: function(data) {
            Model.apply(this, arguments);
            this.items = new NewsCollection(data ? data.items : [], { parse: true });
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.items.dispose();
            Model.prototype.dispose.apply(this, arguments);
        },
        _preprocessNews: function(allNews){
            if(allNews){
                _.each(allNews, function(news){
                    news.tags = news.tags ? news.tags.split(',') : [];
                });
                return allNews;
            } else { return []; }
        },
        parse: function(data) {
            var items = this._preprocessNews(data.items);
            this.items.reset(items);
            return data;
        },
        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);
            return params;
        }
    });

    return NewsModel;
});
